export const API_CARRIER_LOYALTY_INFO = '/carrier/info';
export const API_CARRIER_HAS_LOYALTY = '/carrier/has-loyalty';
export const API_CASHBACK_HISTORY = '/cashback/history';
export const API_APPLY_CASHBACK = '/cashback/apply';
export const API_MAX_CASHBACK_BY_ORDER_ID = (orderId: string): string => `/order/${orderId}`;
